import { isLocalHost } from "../Resource/ResourceManager";

// Facebook Pixel
declare const fbq: any;
declare const window: Window & { fbq?: Function };

let _fbqUndefined: boolean = false;

export namespace FBPixel {
    export function track(event: string, data?: any) {
        /*if(_fbqUndefined) return;
        else if(!window.fbq) {
            // Log once then kill the module
            console.error("Cannot log %O to fbq; window.fbq is undefined", event);
            _fbqUndefined = true;
            return;
        }
        try {
            if (isLocalHost) return;
            fbq('trackCustom', event, data);
            console.info(`FBPixel: Sent '${event}' with data:`, data);
        } catch (e) {
            console.warn('Failed to track', e);
        }*/
    }
}
